import SearchableMultiSelectFilter from './SearchableMultiSelectFilter.component';

export default SearchableMultiSelectFilter;
